<template>
  <div class="row">
    <div class="col-12">
      <h2 class="contact-title">Get in Touch</h2>
    </div>
    <div class="col-lg-8 mb-4 mb-lg-0">
      <form class="form-contact contact_form" @submit.prevent="submit">
        <div class="row">
          <div class="col-12">
            <div class="form-group" :class="{ 'form-group--error': $v.message.$error }">
              <textarea
                class="form-control w-100"
                name="message"
                id="message"
                cols="30"
                rows="9"
                v-model.trim="$v.message.$model"
                placeholder="Enter Message"
              ></textarea>
              <small class="form-text text-muted" v-if="!$v.message.required">Please type your message</small>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
              <input
                class="form-control"
                name="name"
                id="name"
                v-model.trim="$v.name.$model"
                type="text"
                placeholder="Enter your name"
              />
              <small class="form-text text-muted" v-if="!$v.name.required">Please type your name</small>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
              <input
                class="form-control"
                name="email"
                id="email"
                v-model.trim="$v.email.$model"
                type="email"
                placeholder="Enter email address"
              />
              <small class="form-text text-muted" v-if="!$v.email.required">Please type a valid email address</small>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
              <input
                class="form-control"
                name="subject"
                id="subject"
                type="text"
                v-model.trim="$v.subject.$model"
                placeholder="Enter Subject"
              />
              <small class="form-text text-muted" v-if="!$v.subject.required">Please type the title of your message</small>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg-3">
          <button
            type="submit"
            v-bind:class="$v.$invalid? 'btn btn-secondary disabled':'btn btn-success'"
            :disabled="$v.$invalid"
            v-on:click="submit"
          >Send Message</button>
          <p class="typo__p" v-if="submitStatus === 'OK'">Thanks for your submission!</p>
          <p class="typo__p" v-if="submitStatus === 'ERROR'">Please fill the form correctly.</p>
          <p class="typo__p" v-if="submitStatus === 'PENDING'">Sending...</p>
        </div>
      </form>
    </div>

    <Address />
  </div>
</template>
<script>
import Address from '@/components/ContactAddress'
import { required, minLength, email } from 'vuelidate/lib/validators'
import axios from 'axios'

export default {
  data () {
    return {
      message: '',
      email: '',
      name: '',
      subject: '',
      submitStatus: null,
      form_id: ''
    }
  },
  components: {
    Address
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
    email: {
      required,
      email
    },
    subject: {
      required
    },
    message: {
      required
    }
  },
  methods: {
    submit () {
      console.log('submit!')
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        const message = {
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        }
        const url = 'https://formspree.io/mbjzzbqb'
        axios
          .post(url, message)
          .then(res => {
            this.submitStatus = 'OK'
            this.$swal('Thank you. Your message was sent')
          })
          .catch(err => {
            console.log(err)
            this.submitStatus = 'PENDING'
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue